export default [
  "https://youtube.com/embed/ogemwbCg_gc",
  "https://youtube.com/embed/b-5z3Mgfldo",
  "https://youtube.com/embed/rwQ_RDhKit8",
];
